import React, { useEffect, useRef, useState } from "react";
import "./ComparePlans.css";
import { checkPermission, pricePlanCalc } from "../../../../services/utils";
import { FormattedMessage } from "react-intl";
import CustomToolTip from "../../../../components/CustomToolTip/CustomToolTip";
import Faq from "./Faq/Faq";
export default function ComparePlans({
  plans,
  toggle,
  onSelectPlan,
  organizationCredits,
  subscriptionType,
}) {
  const [position, setPosition] = useState("");

  useEffect(() => {
    const element = document.querySelector("#compare-plans");
    if (element) {
      document.addEventListener("scroll", (event) => {
        if (window.scrollY > element.offsetTop) {
          setPosition("fix-head");
        } else {
          setPosition("");
        }
      });
    }
  }, [toggle]);

  return (
    toggle && (
      <PlansTable
        plans={plans}
        onSelectPlan={onSelectPlan}
        headPosition={position}
        currentPlan={organizationCredits && organizationCredits.plan}
        subscriptionType={subscriptionType}
      />
    )
  );
}

function PlansTable({
  plans,
  onSelectPlan,
  headPosition,
  currentPlan,
  subscriptionType,
}) {
  return (
    <div id={"compare-plans"}>
      <div className={"plan-info-container"}>
        <div className={"head-wrapper " + headPosition}>
          <div className={"itm-head itm bdy-action-name"}></div>
          <div className={"itm-head-wrapper "}>
            <div className={"top-gradient-line compare"} />
            <div className={"itm-choose-plan"}>
              {plans.map((plan, i) => (
                <div className={"itm-head itm"} key={i}>
                  <h4>{plan.name}</h4>{" "}
                  <div className={"plan-btn-wrapper plan-card-content"}>
                    {currentPlan && currentPlan.planId === plan.planId ? (
                      <button className="plan-btn current">
                        <FormattedMessage id={"billing.currentPlan"} />
                      </button>
                    ) : (
                      <button
                        className={"plan-btn"}
                        onClick={() => onSelectPlan(plan)}
                      >
                        <FormattedMessage id={"billing.choosePlan"} />
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {plans[3].permissions.map((permission, i) => {
          if (
            [
              "TeamActivity",
              "TeamReports",
              "Tags",
              "PublicApi",
              "Sequence",
              "Tasks",
              "Notes",
              "WaitingList",
            ].indexOf(permission.name) > -1
          ) {
            return null;
          }

          return (
            <div className={"bdy-wrapper"} key={i}>
              {/* {permission.name !== "SupportedAutomationTypes" &&
                plans[0].permissions[i - 1] &&
                plans[0].permissions[i - 1].name !== "Workflow" && (
                  <div className={"bdy-itm-wrapper"}>
                    <div className={"permission-name itm"}>
                      <FormattedMessage
                        id={"billing.permissions." + permission.name}
                      />
                    </div>
                  </div>
                )}*/}
              <div className={"bdy-itm-wrapper"}>
                <div className={"permission-name itm"}>
                  <FormattedMessage
                    id={"billing.permissions." + permission.name}
                  />
                </div>
              </div>
              {permission.name == "MemberPermission" && (
                <>
                  <GetPlanParams
                    plans={plans}
                    objectKey={"workEmailCreditsPerSeat"}
                    tid={"workEmailCredits"}
                    isAnnual={subscriptionType === "yearly"}
                    isCredit
                  />
                  <GetPlanParams
                    plans={plans}
                    objectKey={"phoneCredits"}
                    tid={"phoneCredits"}
                    isAnnual={subscriptionType === "yearly"}
                    isCredit
                  />
                  <GetPlanParams
                    plans={plans}
                    objectKey={"personalEmailCredits"}
                    tid={"personalEmailCredits"}
                    isAnnual={subscriptionType === "yearly"}
                    isCredit
                  />
                  <GetPlanParams
                    plans={plans}
                    objectKey={"exportCredits"}
                    tid={"exportCredits"}
                    isAnnual={subscriptionType === "yearly"}
                    isCredit
                  />

                  <GetPlanParams
                    plans={plans}
                    objectKey={"isCumulative"}
                    tid={"creditsRollOver"}
                    positive={<FormattedMessage id={"billing.yes"} />}
                    negative={<FormattedMessage id={"billing.no"} />}
                  />
                  {/*     <GetPlanParams
                    plans={plans}
                    objectKey={"maxSeats"}
                    tid={"guests"}
                  />*/}
                  <GetPlanParams
                    plans={plans}
                    objectKey={"maxAdmins"}
                    tid={"adminRole"}
                    tooltipId={"billing.plan.adminRoleTooltip"}
                  />
                  <GetPlanParams
                    plans={plans}
                    tid={"MemberPermission"}
                    permission={"MemberPermission"}
                    action={"Edit"}
                    positive={
                      <FormattedMessage id={"billing.customPermissions"} />
                    }
                    negative={
                      <FormattedMessage id={"billing.notCustomizable"} />
                    }
                  />
                  <GetPlanParams
                    plans={plans}
                    tid={"TeamActivity"}
                    permission={"TeamActivity"}
                    showActions={true}
                  />
                  <GetPlanParams
                    plans={plans}
                    tid={"TeamReports"}
                    permission={"TeamReports"}
                    showActions={true}
                  />
                </>
              )}
              {permission.name == "Workflow" && (
                <>
                  <GetPlanParams
                    plans={plans}
                    objectKey={"numberOfWorkflow"}
                    tid={"enrichmentWorkflowB2b"}
                  />
                  <GetPlanParams
                    plans={plans}
                    objectKey={"numberOfWorkflowLaunches"}
                    tid={"workflowLaunchesPerMonth"}
                  />
                  <GetPlanParams
                    plans={plans}
                    objectKey={"contactPerLaunch"}
                    tid={"enrichmentPerSearch"}
                  />
                  <GetPlanParams
                    plans={plans}
                    objectKey={"numberOfSequences"}
                    tid={"numberOfSequences"}
                    customText={" default sequences"}
                    tooltipId={"billing.plan.numberOfSequencesToolTip"}
                  />
                </>
              )}

              {permission.actions.map((action, i) => {
                if (
                  permission.name === "MemberPermission" ||
                  permission.name === "Workflow" ||
                  action === "Allwebsites"
                )
                  return null;
                if (
                  permission.name === "SupportedAutomationTypes" &&
                  (action == "Linkedin" ||
                    action == "SalesNavigator" ||
                    action == "Recruiter")
                ) {
                  return null;
                }

                return (
                  <div className={"bdy-itm-wrapper line"} key={i}>
                    <div className={"bdy-action-name itm"}>
                      <FormattedMessage id={"billing.actions." + action} />
                    </div>

                    {plans.map((plan, indx) => {
                      if (
                        plan.planId == "0" &&
                        permission.name === "SupportedWebsites" &&
                        (action == "SalesNavigator" || action == "Recruiter")
                      ) {
                        return (
                          <div className={"bdy-permission itm"} key={indx}>
                            <FormattedMessage id={"billing.no"} />
                          </div>
                        );
                      }
                      if (
                        plan.planId == "plan_1" &&
                        permission.name === "SupportedWebsites" &&
                        action == "Recruiter"
                      ) {
                        return (
                          <div className={"bdy-permission itm"} key={indx}>
                            <FormattedMessage id={"billing.no"} />
                          </div>
                        );
                      }
                      if (
                        permission.name === "Support" &&
                        plan.planId !== "plan_3"
                      ) {
                        return (
                          <div className={"bdy-permission itm"} key={indx}>
                            <FormattedMessage id={"billing.no"} />
                          </div>
                        );
                      }
                      if (
                        permission.name === "Integration" &&
                        action == "Zapier" &&
                        plan.planId == "0"
                      ) {
                        return (
                          <div className={"bdy-permission itm"} key={indx}>
                            <FormattedMessage id={"billing.no"} />
                          </div>
                        );
                      }
                      return (
                        <div className={"bdy-permission itm"} key={indx}>
                          {checkPermission({
                            permissions: plan.permissions,
                            name: permission.name,
                            action,
                          }) ? (
                            <FormattedMessage
                              id={
                                action == "Gmail"
                                  ? "workflow.comingSoon"
                                  : "billing.yes"
                              }
                            />
                          ) : (
                            <FormattedMessage
                              id={
                                action == "Gmail"
                                  ? "workflow.comingSoon"
                                  : "billing.yes"
                              }
                            />
                          )}{" "}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
              {permission.name == "Leads" && (
                <>
                  <GetPlanParams
                    plans={plans}
                    objectKey={"maxLists"}
                    tid={"maxLists"}
                  />
                  <GetPlanParams
                    plans={plans}
                    tid={"Tags"}
                    permission={"Tags"}
                    positive={<FormattedMessage id={"billing.yes"} />}
                    negative={<FormattedMessage id={"billing.no"} />}
                  />
                  <GetPlanParams
                    plans={plans}
                    tid={"Tasks"}
                    permission={"Tasks"}
                    positive={<FormattedMessage id={"billing.yes"} />}
                    negative={<FormattedMessage id={"billing.no"} />}
                  />
                  <GetPlanParams
                    plans={plans}
                    tid={"Notes"}
                    permission={"Notes"}
                    positive={<FormattedMessage id={"billing.yes"} />}
                    negative={<FormattedMessage id={"billing.no"} />}
                  />
                  <GetPlanParams
                    plans={plans}
                    tid={"WaitingList"}
                    permission={"WaitingList"}
                    positive={<FormattedMessage id={"billing.yes"} />}
                    negative={<FormattedMessage id={"billing.no"} />}
                    tooltipId={"billing.permissions.WaitingListTooltio"}
                  />
                </>
              )}
              {permission.name == "SupportedWebsites" && (
                <>
                  <GetPlanParams
                    plans={plans}
                    customTid={"billing.plan.publicApiAccess"}
                    tid={"PublicApi"}
                    permission={"PublicApi"}
                    positive={<FormattedMessage id={"billing.yes"} />}
                    negative={<FormattedMessage id={"billing.no"} />}
                  />
                  <GetPlanParams
                    plans={plans}
                    objectKey={"publicApiLimits"}
                    secondObjectKey={"minute"}
                    tid={"requestApiPerMinute"}
                  />
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function GetPlanParams({
  plans,
  objectKey,
  tid,
  permission,
  positive,
  negative,
  action,
  showActions,
  tooltipId,
  isAnnual,
  isCredit,
  customTid,
  secondObjectKey,
}) {
  if (showActions) {
    return (
      <div className={"bdy-itm-wrapper line"}>
        <div className={"bdy-action-name itm"}>
          {customTid ? (
            <FormattedMessage id={customTid} />
          ) : (
            <FormattedMessage id={"billing.permissions." + tid} />
          )}{" "}
          {tooltipId && (
            <CustomToolTip element={<FormattedMessage id={tooltipId} />}>
              <img src="/assets/images/icon-info.svg" alt="" />
            </CustomToolTip>
          )}
        </div>
        {plans.map((plan) => {
          let currentPermission = plan.permissions.find(
            (p) => p.name === permission
          );
          let actions =
            currentPermission && currentPermission.actions.join(" & ");
          return <div className={"bdy-permission itm"}>{actions || "--"}</div>;
        })}
      </div>
    );
  }
  if (positive && negative && permission) {
    return (
      <div className={"bdy-itm-wrapper line"}>
        <div className={"bdy-action-name itm"}>
          {customTid ? (
            <FormattedMessage id={customTid} />
          ) : (
            <FormattedMessage id={"billing.permissions." + tid} />
          )}
          {tooltipId && (
            <CustomToolTip
              element={<FormattedMessage id={tooltipId} />}
              style={{ width: 250 }}
            >
              <img src="/assets/images/icon-info.svg" alt="" />
            </CustomToolTip>
          )}
        </div>
        {plans.map((plan, i) => {
          let currentPermission = plan.permissions.find(
            (p) => p.name === permission
          );

          return (
            <div className={"bdy-permission itm"} key={i}>
              {!!currentPermission ? positive : negative}
            </div>
          );
        })}
      </div>
    );
  }
  if (permission) {
    return (
      <div className={"bdy-itm-wrapper line"}>
        <div className={"bdy-action-name itm"}>
          {customTid ? (
            <FormattedMessage id={customTid} />
          ) : (
            <FormattedMessage id={"billing.plan." + tid} />
          )}{" "}
          {tooltipId && (
            <CustomToolTip
              element={<FormattedMessage id={tooltipId} />}
              style={{ width: 250 }}
            >
              <img src="/assets/images/icon-info.svg" alt="" />
            </CustomToolTip>
          )}
        </div>
        {plans.map((plan) => {
          let currentPermission = plan.permissions.find(
            (p) => p.name === permission
          );
          let isActionAllowed =
            currentPermission && currentPermission.actions.indexOf(action) > -1;
          return (
            <div className={"bdy-permission itm"}>
              {isActionAllowed ? positive : negative}
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className={"bdy-itm-wrapper line"}>
      <div className={"bdy-action-name itm"}>
        <FormattedMessage id={"billing.plan." + tid} />{" "}
        {tooltipId && (
          <CustomToolTip
            element={<FormattedMessage id={tooltipId} />}
            style={{ width: 250 }}
          >
            <img src="/assets/images/icon-info.svg" alt="" />
          </CustomToolTip>
        )}
      </div>
      {plans.map((plan, i) => {
        return (
          <div className={"bdy-permission itm"} key={i}>
            {(() => {
              if (typeof plan[objectKey] == "boolean") {
                return plan[objectKey] ? positive : negative;
              }
              if (objectKey && secondObjectKey) {
                return plan[objectKey][secondObjectKey];
              }
              if (plan[objectKey] === -1 || plan[objectKey] === 10000) {
                return "Unlimited";
              }
              if (plan.planId == "0" && objectKey == "maxAdmins") {
                return "--";
              }
              if (
                (isAnnual || plan.planId == "plan_3") &&
                objectKey !== "maxAdmins" &&
                plan.planId !== "0"
              ) {
                return plan[objectKey] * 12;
              }
              return plan[objectKey];
            })()}
          </div>
        );
      })}
    </div>
  );
}
